import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import "@olmokit/core/forms/checkbox";
import FormsTextareaMaterial from "@olmokit/core/forms/textarea/material";
import "components/Fields/Multiselect/base.scss";
import "@olmokit/core/forms/file/material";
import FormsMultiSelectMaterial from "components/Fields/Multiselect/base";
import Olmoforms from "components/Form/feedback";
import Dependency from "@olmokit/core/olmoforms/dependency";
import { countryEndpoint, hideProject, showProject } from "components/Form";
import { $, on } from "@olmokit/dom";
import { dataLayerFillingForm, dataLayerForm } from "components/Datalayer";
import { salesforceCommunication } from "components/Form";
import "./Material.scss";

/**
 * Component: FormProductCart
 */
export function FormMaterial() {
  console.log("FormMaterial mounted.");

  dataLayerFillingForm('#contactmaterial .of:el', 'Form Material')

  const $container = $('.FormMaterial: .of:country');
  const $country = $('select', $container);

  on($country, 'change', () => {   
    countryEndpoint(".FormMaterial:", $country.value);
  });

  const $jobcontainer = $('.FormMaterial: .of:job');
  const $jobfield = $('select', $jobcontainer);
  const $projcontainer = $('.FormMaterial: .of:project');
  const $projfield = $('select', $projcontainer);
  const $mqcontainer = $('.FormMaterial: .of:projectmq');
  const $yearcontainer = $('.FormMaterial: .of:projectyear');

  on($jobfield, 'change', () => {   
    if ($jobfield.value == 'Press Stampa') {
      hideProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
    } else {
      $projcontainer.style.display = 'block';
      showProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
    }
  });
  on($projfield, 'change', () => {
    showProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
  })

  const olmoforms = Olmoforms(".FormMaterial:", {
    before: (formData) => {
      console.log(formData);
      const $localcheck = $('#of-5-localcheck');
      if($localcheck.value != ''){
        console.log('stopped');
        olmoforms.boot()
      }
    },    
    sent: (formData) => {
      dataLayerForm("form sent", formData, "Form Material", $('#of-3-usertype').value, $('#of-3-requesttype').value);
      salesforceCommunication(formData, "Form Material");
    }, 
    failed: (instance) => dataLayerForm("form_error", '', "Form Material", $('#of-3-usertype').value, $('#of-3-requesttype').value)
  });

  FormsInputMaterial();
  Dependency(".FormMaterial:");
  FormsSelectMaterial();
  FormsMultiSelectMaterial();
  FormsTextareaMaterial();

  return {
    destroy() {
      olmoforms.destroy();
    },
  };


}
